















































import { Component, Inject, Mixins, Prop } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { IImportMapping, IStepMappingsProviderMethods } from "@/models/imports";
import { UpmindObjectMap, UpmindObjectTypes } from "@/data/enums/objects";
import { IUser } from "@/models/users";

interface IManualMappingForm {
  objectId: string;
}

@Component({
  components: {
    "select-brand-gateway": () =>
      import("@/components/app/admin/imports/selectBrandGateway.vue"),
    "select-custom-field": () =>
      import("@/components/app/admin/imports/selectCustomField.vue"),
    "select-priority": () =>
      import("@/components/app/admin/imports/selectPriority.vue"),
    "select-product-category": () =>
      import("@/components/app/admin/imports/selectProductCategory.vue"),
    "select-provision-configuration": () =>
      import("@/components/app/admin/imports/selectProvisionConfiguration.vue"),
    "select-status": () =>
      import("@/components/app/admin/imports/selectStatus.vue"),
    "select-ticket-department": () =>
      import("@/components/app/admin/imports/selectTicketDepartment.vue"),
    "select-user-group": () =>
      import("@/components/app/admin/imports/selectUserGroup.vue"),
    "user-search-table": () =>
      import("@/components/app/global/user/userSearchTable.vue")
  }
})
export default class SelectMappingModal extends Mixins(HasValidation) {
  // Inject

  @Inject({ from: "mappingMethods" })
  public readonly $mappingMethods!: IStepMappingsProviderMethods;

  // Props

  @Prop({ required: true })
  public mapping!: IImportMapping;

  // Data

  public isProcessing = false;
  public form: IManualMappingForm = {
    objectId: ""
  };

  // Computed

  public get objectName() {
    const map = UpmindObjectMap()[this.mapping.object_type];
    return (this.$_.get(
      map,
      "name",
      this.mapping.object_type
    ) as string).toLowerCase();
  }

  public get selector() {
    switch (this.mapping.object_type) {
      case UpmindObjectTypes.CUSTOM_FIELD:
        return {
          is: "select-custom-field"
        };
      case UpmindObjectTypes.GATEWAY:
        return {
          is: "select-brand-gateway"
        };
      case UpmindObjectTypes.GROUP:
        return {
          is: "select-user-group"
        };
      case UpmindObjectTypes.PRIORITY:
        return {
          is: "select-priority"
        };
      case UpmindObjectTypes.PRODUCTS_CATEGORY:
        return {
          is: "select-product-category"
        };
      case UpmindObjectTypes.PROVISION_CONFIGURATION:
        return {
          is: "select-provision-configuration"
        };
      case UpmindObjectTypes.STATUS:
        return {
          is: "select-status"
        };
      case UpmindObjectTypes.TICKET_DEPARTMENT:
        return {
          is: "select-ticket-department"
        };
      case UpmindObjectTypes.USER:
        return {
          is: "user-search-table",
          props: {
            limit: 6,
            rowTag: "a",
            autoFocusSearch: true,
            manualFilters: {
              with_staged_imports: 1
            },
            rowProps: () => ({}),
            rowEvents: (user: IUser) => ({
              click: () =>
                this.onSelect(
                  this.mapping.object?.id === user.id ? null : user.id
                )
            })
          }
        };
      default:
        return {};
    }
  }

  public get isCategorySelector() {
    return this.mapping.object_type === UpmindObjectTypes.PRODUCTS_CATEGORY;
  }

  // Methods

  public async submitManualObjectId() {
    try {
      this.isProcessing = true;
      // Validate formasdfas
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      // Update mapping
      await this.$mappingMethods.update(this.mapping.id, this.form.objectId);
      // Close modal
      this.$emit("close");
    } catch (error) {
      this.isProcessing = false;
      // Handle error
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }

  public onSelect(value) {
    if (!this.isCategorySelector) return this.$emit("onSelect", value);
    this.form.objectId = value;
  }
}
